import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// api
import { getAllOrders } from 'api/orders';
// constants
import { getPaymentStatus, getOrderStatus } from 'constants';
// components
import AutoCompleteInput from './autoCompleteInput';

const SearchOrder = ({
  onSelected,
  placeholder,
  defaultOrder = null,
  showLabel = '',
}) => {
  const { t } = useTranslation(['backoffice']);
  const [orderSelected, setOrderSelected] = useState(null);
  const paymentStatus = getPaymentStatus(t);
  const orderStatus = getOrderStatus(t)

  useEffect(() => {
    if (defaultOrder) {
      setOrderSelected({
        label: `#${defaultOrder.code}`,
        value: defaultOrder.id,
      });
    } else setOrderSelected(null);
  }, [defaultOrder]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getAllOrders({
        code: value,
        page: 1,
        page_size: 10,
      });
      if (status === 200) {
        const arr = data?.results?.filter((el) => el.payment_status === paymentStatus[1].id || el.status.id === orderStatus[3].id);
        return arr.map((item) => {
          return {
            ...item,
            label: `#${item.code}`,
            value: item.id,
          };
        });
      }
    }
    return [];
  };

  return (
    <AutoCompleteInput
      label={showLabel}
      defaultOptions={orderSelected ? [orderSelected] : []}
      defaultValue={orderSelected}
      onSelect={onSelected}
      onSearch={onSearch}
      placeholder={placeholder}
    />
  );
};

SearchOrder.propTypes = {
  placeholder: PropTypes.string,
  onSelected: PropTypes.func.isRequired,
  defaultOrder: PropTypes.object,
  showLabel: PropTypes.string,
  fields: PropTypes.string,
};

export default SearchOrder;
